import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import PhoneIcon from '@components/icons/Phone.svg';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { useAPI } from '@providers/useAPI';
import { AdminService } from 'app/API';
import React, { useState } from 'react';

import { Content } from './EditUserPhoneModal/styles/Content';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
  id: string;
  phone: string;
};

export const AdminEditUserPhoneModal = ({ onCancel, onSuccess, id, phone }: TProps) => {
  const { call } = useAPI();
  const [newPhone, setNewPhone] = useState(phone);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    await call(AdminService.updateUserPhone({ userId: id, requestBody: { phone: newPhone } }));
    setIsSubmitting(false);
    onSuccess();
  };

  return (
    <ModalWrapper width="300px">
      <ModalTitle>Edit User Phone</ModalTitle>
      <Content>
        <form action="#" onSubmit={submit}>
          <div className="inputWrapper">
            <Input
              icon={PhoneIcon}
              required
              value={newPhone}
              type="text"
              label="Phone"
              name="phone"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewPhone(e.target.value)}
              error={isSubmitting && !newPhone}
            />
          </div>
          <div className="buttonWrapper">
            <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
            <Button type="submit" disabled={!newPhone.length}>
              Save
            </Button>
          </div>
        </form>
      </Content>
    </ModalWrapper>
  );
};
